import Markdown from 'markdown-to-jsx'

export interface MarkdownTooltipProps {
  children?: string
}

export const MarkdownTooltip = ({children}: MarkdownTooltipProps) => {
  return <Markdown>{children || ''}</Markdown>
}
